(function () {
  'use strict';

  const ICON_ZOOM_IN = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>`;
  const ICON_ZOOM_OUT = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>`;

  let _blockClose = false;
  let _dragState  = null;
  let _dragMoved  = false;
  let _skipClick  = false;
  let _busy       = false;

  /* ── 1. Set block flag on mousedown inside dialog (not on close/zoom btn) */
  document.addEventListener('mousedown', function (e) {
    const zd = e.target.closest('zoom-dialog');
    if (!zd) return;
    const dlg = zd.querySelector('dialog');
    if (!dlg?.open) return;
    if (e.target.closest('.dialog-zoomed-gallery__close-button')) return;
    if (e.target.closest('.wallz-zoom-btn')) return;
    _blockClose = true;
  }, true);

  /* ── 2. Patch both zd.close() AND native dialog.close() ─────────────── */
  function patchZoomDialog(zd) {
    if (zd._wzPatched) return;
    zd._wzPatched = true;

    // Patch the Component's async close() — stops animation before it starts
    const proto = Object.getPrototypeOf(zd);
    const originalClose = proto.close;
    zd.close = async function () {
      if (_blockClose) { _blockClose = false; return; }
      return originalClose.call(this);
    };

    // Also patch native dialog.close() as safety net
    const dlg = zd.querySelector('dialog');
    if (dlg && !dlg._wz) {
      dlg._wz = true;
      const nativeClose = HTMLDialogElement.prototype.close;
      dlg.close = function (...a) {
        if (_blockClose) { _blockClose = false; return; }
        nativeClose.apply(this, a);
      };
      dlg.addEventListener('close', () => { _blockClose = false; });
    }
  }

  /* ── 3. Zoom button injection ────────────────────────────────────────── */
  function bestContainer(zd) {
    const cx = window.innerWidth / 2;
    return [...zd.querySelectorAll('.product-media-container')].reduce((b, c) => {
      const r = c.getBoundingClientRect();
      const d = Math.abs(r.left + r.width / 2 - cx);
      if (!b) return c;
      const br = b.getBoundingClientRect();
      return d < Math.abs(br.left + br.width / 2 - cx) ? c : b;
    }, null);
  }

  function injectBtn(zd) {
    patchZoomDialog(zd);
    if (zd.querySelector('.wallz-zoom-btn')) return;
    const closeBtn = zd.querySelector('.dialog-zoomed-gallery__close-button');
    if (!closeBtn) return;

    const btn = document.createElement('button');
    btn.className = 'wallz-zoom-btn button button-unstyled';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Inzoomen');
    btn.innerHTML = ICON_ZOOM_IN;
    closeBtn.parentNode.insertBefore(btn, closeBtn);

    const dlg = zd.querySelector('dialog');
    if (dlg) {
      dlg.addEventListener('close', () => {
        btn.innerHTML = ICON_ZOOM_IN;
        btn.setAttribute('aria-label', 'Inzoomen');
        _busy = false;
        zd.querySelectorAll('.product-media-container.is-zoomed').forEach(c => {
          c.classList.remove('is-zoomed');
          const el = c.querySelector('.product-media__drag-zoom-wrapper') || c.querySelector('img.product-media__image');
          if (el) el.style.cssText = '';
        });
      });
    }

    btn.addEventListener('click', function (e) {
      if (window.innerWidth < 750) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      if (_busy) return;
      _busy = true;
      doZoom(zd, btn);
    }, true);
  }

  /* ── 4. Zoom in / out ───────────────────────────────────────────────── */
  function doZoom(zd, btn) {
    const c = bestContainer(zd);
    if (!c) { _busy = false; return; }

    const zoomed  = c.classList.contains('is-zoomed');
    const wrapper = c.querySelector('.product-media__drag-zoom-wrapper');
    const img     = c.querySelector('img.product-media__image');
    const el      = wrapper || img;

    if (!zoomed) {
      btn.innerHTML = ICON_ZOOM_OUT;
      btn.setAttribute('aria-label', 'Uitzoomen');
      if (el) {
        el.style.cssText = '';
        el.style.transition = 'transform 0.3s cubic-bezier(0.4,0,0.2,1)';
        el.style.transformOrigin = 'center center';
        requestAnimationFrame(() => {
          el.style.transform = 'scale(3)';
          setTimeout(() => {
            el.style.cssText = '';
            c.classList.add('is-zoomed');
            el.style.transform = 'translate(0px,0px)';
            _busy = false;
          }, 320);
        });
      } else {
        c.classList.add('is-zoomed');
        _busy = false;
      }
    } else {
      btn.innerHTML = ICON_ZOOM_IN;
      btn.setAttribute('aria-label', 'Inzoomen');
      if (el && img) {
        const s = Math.min(c.offsetWidth / (img.naturalWidth || 1), c.offsetHeight / (img.naturalHeight || 1));
        el.style.transition = 'transform 0.3s cubic-bezier(0.4,0,0.2,1)';
        el.style.transformOrigin = 'center center';
        el.style.transform = `scale(${s})`;
        setTimeout(() => {
          el.style.cssText = '';
          c.classList.remove('is-zoomed');
          _busy = false;
        }, 320);
      } else {
        if (el) el.style.cssText = '';
        c.classList.remove('is-zoomed');
        _busy = false;
      }
    }
  }

  /* ── 5. Drag-to-pan ─────────────────────────────────────────────────── */
  document.addEventListener('mousedown', function (e) {
    if (window.innerWidth < 750) return;
    const c = e.target.closest('zoom-dialog .product-media-container.is-zoomed');
    if (!c) return;
    const el = c.querySelector('.product-media__drag-zoom-wrapper') || c.querySelector('img.product-media__image');
    if (!el) return;
    const m = new DOMMatrix(getComputedStyle(el).transform);
    _dragState = { x0: e.clientX, y0: e.clientY, tx: m.m41, ty: m.m42, el, c };
    _dragMoved = false;
    e.preventDefault();
  });

  document.addEventListener('mousemove', function (e) {
    if (!_dragState) return;
    const dx = e.clientX - _dragState.x0;
    const dy = e.clientY - _dragState.y0;
    if (!_dragMoved && Math.abs(dx) < 3 && Math.abs(dy) < 3) return;
    _dragMoved = true;
    const { el, c, tx, ty } = _dragState;
    const img = c.querySelector('img.product-media__image');
    const iW  = img ? img.offsetWidth  : el.offsetWidth;
    const iH  = img ? img.offsetHeight : el.offsetHeight;
    const ox  = Math.max(0, (iW - c.offsetWidth)  / 2);
    const oy  = Math.max(0, (iH - c.offsetHeight) / 2);
    const nx  = Math.max(-ox, Math.min(ox, tx + dx));
    const ny  = Math.max(-oy, Math.min(oy, ty + dy));
    el.style.transform = `translate(${nx}px,${ny}px)`;
  });

  document.addEventListener('mouseup', function () {
    if (_dragMoved) { _skipClick = true; _blockClose = true; }
    _dragState = null;
    _dragMoved = false;
  });

  document.addEventListener('click', function (e) {
    if (_skipClick) { _skipClick = false; e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);

  /* ── 6. Init ─────────────────────────────────────────────────────────── */
  const init = () => document.querySelectorAll('zoom-dialog').forEach(injectBtn);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();